var _rect, _g, _rect2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1235 650",
    width: 1235,
    height: 650,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 650,
    fill: "#b22234"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 50,
    width: 1235,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    y: 150,
    width: 1235,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    y: 250,
    width: 1235,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    y: 350,
    width: 1235,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    y: 450,
    width: 1235,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    y: 550,
    width: 1235,
    height: 50
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 350,
    fill: "#3c3b6e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "usrow"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 40,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 40,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 40,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 40,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 40,
    r: 14
  })), /*#__PURE__*/React.createElement("use", {
    href: "#usrow",
    y: 58
  }), /*#__PURE__*/React.createElement("use", {
    href: "#usrow",
    y: 116
  }), /*#__PURE__*/React.createElement("use", {
    href: "#usrow",
    y: 174
  }), /*#__PURE__*/React.createElement("use", {
    href: "#usrow",
    y: 232
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 69,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 69,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 69,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 69,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 69,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 127,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 127,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 127,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 127,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 127,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 185,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 185,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 185,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 185,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 185,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 243,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 243,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 243,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 243,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 243,
    r: 14
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.27a00388aca6af41d4234ef5333f04b2.svg";
export { ForwardRef as ReactComponent };